// extracted by mini-css-extract-plugin
module.exports = {"callbackModal":"CallbackModal_callbackModal__792sV","callbackFormWrapper":"CallbackModal_callbackFormWrapper__HBc7y"};